import React from 'react';
import { Icon } from './Icon.js';
export const IconChatBubbleClip = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M19 6V2H16V7C16 8.65685 17.3431 10 19 10C20.6569 10 22 8.65685 22 7V5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13 5H3V21H3.41602L5.37891 17.5098L5.66504 17H21V12.6572C21.7454 12.3937 22.4229 11.9874 23 11.4707V19H6.83398L4.87109 22.4902L4.58496 23H1V3H13V5Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconChatBubbleClip.js.map